import { useState } from "react";
import { Mui } from "@osu/react-ui";
import { getCurrentEasternYear } from "../../util/functions";
import { SESSION_KINDS } from "../../util/constants";
const { useGetSessionsMetadataQuery } = require("../../services/shared/api");

const { FormControl, InputLabel, Select, MenuItem } = Mui;

const currentYear = getCurrentEasternYear();

function PreFilters({ onClick: _onClick, defaultYear = currentYear }) {
  const { data, isLoading } = useGetSessionsMetadataQuery();
  const [year, setYear] = useState(defaultYear);
  const [type] = useState(SESSION_KINDS.FGC);
  const allYears = [...data?.years || [], year, defaultYear].map(String);
  const years = [...new Set(allYears)].sort((a, b) => b - a);
      
  const onClick = () => {
    return _onClick({
      year,
      type,
    });
  };

  if (isLoading) {
    return (
      <Mui.Box display="flex">
        <Mui.Skeleton
          width="8rem"
          height="6rem"
          sx={{
            mr: 2,
          }}
        />
        <Mui.Skeleton width="8rem" height="6rem" />
      </Mui.Box>
    );
  }

  return (
    <Mui.Box display="flex" gap={2} sx={{ mb: 2 }}>
      <FormControl sx={{ minWidth: 120 }}>
        <InputLabel id="year-select-label">Year</InputLabel>
        <Select
          labelId="year-select-label"
          id="year-select"
          value={year}
          label="Year"
          onChange={(event) => setYear(event.target.value)}
        >
          {years.map((yearOption) => (
            <MenuItem key={yearOption} value={yearOption}>
              {yearOption}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* <FormControl sx={{ minWidth: 120 }}>
        <InputLabel id="type-select-label">Type</InputLabel>
        <Select
          labelId="type-select-label"
          id="type-select"
          value={type}
          label="Type"
          onChange={(event) => setType(event.target.value)}
        >
          {types.map((typeOption) => (
            <MenuItem key={typeOption} value={typeOption}>
              {typeOption}
            </MenuItem>
          ))}
        </Select>
      </FormControl> */}
      <Mui.Button variant="outlined" onClick={onClick}>
        Apply Filters 
      </Mui.Button>
    </Mui.Box>
  );
}

export default PreFilters;
